<template>
  <div v-if="links > 1" class="flex justify-between">
    <vs-pagination :total="links" v-model="page"></vs-pagination>
    <p class="self-center">
      <strong>{{ meta.total }}</strong> registro(s) no total
    </p>
  </div>
</template>

<script>
export default {
  name: "paginacao",
  props: ["meta", "handler"],
  data() {
    return {
      page: 1
    };
  },
  computed: {
    links() {
      return Math.ceil(this.meta.total / this.meta.per_page) || 1;
    }
  },
  watch: {
    $route(to) {
      this.page = to.query.page || 1;
    },
    page(newPage) {
      let query = {
        ...this.$route.query,
        page: newPage
      };

      if (!newPage || newPage == 1) {
        delete query.page;
      }

      this.handler(query);
    }
  }
};
</script>